    import React, { useEffect, useState } from 'react';
// ...existing code...

const MainAiInsight: React.FC = () => {
  // Suppression de l'ancien store et du type mal placé
  const [snapshot, setSnapshot] = useState<any>(null);
  useEffect(() => {
    fetch('/api/intelligence/snapshot')
      .then(res => res.json())
      .then(data => setSnapshot(data));
  }, []);

  if (!snapshot) return null;
  const { portfolioHealth, primaryInsight } = snapshot;
  const insightRaw = primaryInsight || {};
  const typeMap = {
    RISK: { color: '#e53935', label: 'Risque', icon: '⚠️' },
    OPPORTUNITY: { color: '#43a047', label: 'Opportunité', icon: '🚀' },
    BALANCE: { color: '#1976d2', label: 'Équilibre', icon: '⚖️' },
  };
  const priorityMap = {
    LOW: 'Faible',
    MODERATE: 'Modérée',
    HIGH: 'Élevée',
    CRITICAL: 'Critique',
  };
  type InsightType = 'RISK' | 'OPPORTUNITY' | 'BALANCE';
  type PriorityLevel = 'LOW' | 'MODERATE' | 'HIGH' | 'CRITICAL';
  const insightType: InsightType = (insightRaw.type as InsightType) || 'BALANCE';
  const priorityLevel: PriorityLevel = (insightRaw.priorityLevel as PriorityLevel) || 'MODERATE';
  const badge = typeMap[insightType] || typeMap['BALANCE'];
  const priorityLabel = priorityMap[priorityLevel] || priorityMap['MODERATE'];

  return (
    <section style={{
      background: '#fff',
      borderRadius: 24,
      padding: '32px 40px',
      boxShadow: '0 2px 16px #0001',
      minHeight: 120,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'center',
      gap: 24,
    }}>
      {/* Bloc Score Santé */}
      <div style={{
        background: '#f5f5f5',
        borderRadius: 16,
        padding: '16px 24px',
        marginBottom: 8,
        fontWeight: 700,
        fontSize: 18,
        color: '#222',
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        maxWidth: 340,
      }}>
        <span>Score Santé : {portfolioHealth?.score}</span>
        <span style={{ fontSize: 15, color: '#888', fontWeight: 500 }}>{portfolioHealth?.explanation}</span>
          </div>
          {/* Bloc Insight */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
            <span style={{
              background: badge.color,
              color: '#fff',
              borderRadius: 8,
              padding: '6px 18px',
              fontWeight: 700,
              fontSize: 16,
              letterSpacing: 1,
              display: 'flex',
              alignItems: 'center',
              gap: 8,
            }}>
              {badge.icon} {badge.label}
            </span>
            <span style={{ fontSize: 15, color: '#555', fontWeight: 600 }}>Priorité : {priorityLabel}</span>
          </div>
          {/* Bloc Contexte Marché */}
          <div style={{ fontSize: 16, color: '#1976d2', fontWeight: 600, marginBottom: 6 }}>
            Contexte Marché
          </div>
          <div style={{ fontSize: 15, color: '#444', marginBottom: 6 }}>
            {insightRaw.context}
          </div>
          {/* Bloc Analyse */}
          <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 6 }}>Analyse</div>
          <div style={{ fontSize: 15, color: '#444', marginBottom: 16 }}>{insightRaw.body}</div>
          {/* Bloc Action */}
          <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 6 }}>Action</div>
          <div style={{ fontSize: 15, color: '#444' }}>{insightRaw.action}</div>
        </section>
      );
    }

export default MainAiInsight;
